import React, { useState, useEffect, useRef, useContext } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { addResumenData, setIdResumen, clearResumenData, updatePrice, setDescuentoTotal, updateDescuento, setDescuento, updateDomainSO, updateDominioPrincipal, removeResumenData, updateResumenProperty, updateResumenData, clearConfigData } from '../../globalslice';
import { LuPencilLine } from "react-icons/lu";
import getProductInfo from '../../services/productInfo';
import Dominio from './Dominio';
import '../../styles/Configuracion.scss';
import bsqicon from '../../images/bsq-icon.svg';
import bsqicon2 from '../../images/bsq-icon-orange.svg';
import alma from '../../images/alma.svg';
import ubuntu from '../../images/ubuntu.svg';
import debian from '../../images/debian.svg';
import CartSteps from '../CartSteps';
import { useTranslation } from 'react-i18next';
import { AuthContext } from '../../Auth';

const periodMapping = {
  "monthly": "1 mes",
  "quarterly": "3 meses",
  "semiannually": "6 meses",
  "annually": "12 meses",
  "biennially": "24 meses",
  "triennially": "36 meses"
};

const Configuracion = () => {
  const [optionsBase, setOptionsBase] = useState([
    'AlmaLinux v9.0',
    'AlmaLinux v9.3',
    'Ubuntu 24.04 LTS',
    'Ubuntu 22.04 LTS',
    'Debian 12.4'
  ]);
  const icons = {
    'AlmaLinux v9.0': alma,
    'AlmaLinux v9.3': alma,
    'Ubuntu 24.04 LTS': ubuntu,
    'Ubuntu 22.04 LTS': ubuntu,
    'Debian 12.4': debian,
  };
  const idproduct = useSelector((state) => state.global.idproduct);
  const currency = useSelector((state) => state.global.currency);
  const period = useSelector((state) => state.global.period);
  const tokenRef = useSelector((state) => state.global.tokenRef);
  const slug = useSelector((state) => state.global.slug);
  const resumenData = useSelector(state => state.global.ResumenData);
  const idResumen = useSelector(state => state.global.idResumen);
  const [leyendaDescu, setleyendaDescu] = useState(false);
  const [icon, setIcon] = useState(bsqicon);
  const [SslDominio, setSslDominio] = useState(null);
  const [productInfo, setProductInfo] = useState([]);
  const [typeProduct, setTypeProduct] = useState(null);
  const [loading, setLoading] = useState(true);
  const [selectedOption, setSelectedOption] = useState(0); 
  const [selectedOption2, setSelectedOption2] = useState(optionsBase[0]);
  const [sosid, setsosid] = useState(null);
  const [isEditing, setIsEditing] = useState(false);
  const [tempResumenData, setTempResumenData] = useState(null);
  const [isValid, setIsValid] = useState(true);
  const dispatch = useDispatch();
  const { t } = useTranslation();
  const initialized = useRef(false);
  const { userAuth } = useContext(AuthContext);

  const handleSelect2 = (option) => {
    setSelectedOption2(option);
    setIsEditing(false);
    // Despachar la acción para actualizar domain_section
    resumenData.forEach(item => {
      if (item.type === 'vps' && item.actual === true) {
        dispatch(updateDomainSO({ id: item.id, newDomainSection: option }));
      }
    });
  };

  useEffect(() => {
    // Crear una fuente de CancelToken
    const abortController = new AbortController();

    const fetchProductInfo = async () => {
      try {
        const clientData = await getProductInfo({ idproduct, currency, tokenRef, slug, token: userAuth?.token }, abortController.signal);
        if (clientData.success === 'success') {
          setProductInfo(clientData);
        }
        setLoading(false);
      } catch (error) {
        setLoading(false);
      }
    };

    const performActions = async () => {
      if (idproduct && currency) {
        await fetchProductInfo(); 
      }
    };

    performActions();
    if (!initialized.current) {
      initialized.current = true
    }
    // Limpiar efecto: cancelar la solicitud si `idproduct` ó `currency` cambia o si el componente se desmonta
    return () => {
      dispatch(clearConfigData()); // limpia resumenData de items con bandera actual:true
      abortController.abort();
    };
  }, [idproduct, tokenRef, slug, dispatch, currency, period, userAuth]);

  useEffect(() => {
    // si el producto no contiene datos
    if (!productInfo?.data) {
      return;
    }

    const changeProduct = async () => {
      let periodoSeleccionado = 0;
      let periodoBuscado = periodMapping[period];
      let leyenda = null;
      let sos = [];
      const selectPeriods = await productInfo?.data.filter((period) => productInfo.Periodicidades || period.Periodo === "12 meses")
        .reduce((acc, period) => {
          const cross = period.DescuentoMostrar ? false : period.Descuento !== period.Precio && period.Descuento !== 0;
          acc[period.Periodo] = {
            cost: period.Descuento,
            cross_price: cross,
            second_price: period.Precio,
          };

          leyenda = period.DescuentoMostrar ? period.Descripción : false;
          setleyendaDescu(leyenda);
          return acc;
        }, {});

      const tiposConPeriodo = ['vps', 'ssl', 'hosting'];

      if (tiposConPeriodo.includes(productInfo.type)) {
        setTypeProduct(productInfo.type);
        periodoSeleccionado = productInfo.data.findIndex(item => item.Periodo === periodoBuscado);
        setSelectedOption(periodoSeleccionado);

        if(productInfo.type === 'vps') {
          sos = productInfo.sos;
        }
      } else if (productInfo.type === 'nbps') {
        setTypeProduct('nbps');
      }

      // Guardar los datos temporalmente hasta que typeProduct esté configurado
      const crosss_price = productInfo?.data[periodoSeleccionado].DescuentoMostrar
        ? false
        : productInfo?.data[periodoSeleccionado].Promo;

      setTempResumenData({
        product: {
          name: productInfo.name,
          smallname: productInfo.smallname,
          description: productInfo.description,
          domain_section: [{ dominio_principal: null }],
          id: idproduct,
        },
        price: {
          cost: productInfo?.data[periodoSeleccionado].Descuento,
          second_price: productInfo?.data[periodoSeleccionado].Precio,
          cross_price: crosss_price,
        },
        prices: productInfo?.data,
        periodo: productInfo?.data[periodoSeleccionado].Periodo,
        id: idResumen,
        actual: true,
        type: productInfo.type,
        selectPeriods: selectPeriods,
        isOX: productInfo.is_ox,
        isWP: productInfo.is_wp,
        priceDealer: productInfo.price_dealer,
        sos: sos
      });

      dispatch(setIdResumen());
    };

    changeProduct();
  }, [productInfo]);

  useEffect(() => {
    if (productInfo?.data) {
      handleOptionChange(selectedOption);
    }
  }, [userAuth]);

  function identifyPanel(name) {
    if (name.includes("Direct Admin")) {
      return "Direct Admin";
    } else if (name.includes("cPanel")) {
      return "cPanel";
    } else {
      return "Sin panel";
    }
  }

  // Este efecto se ejecutará cuando typeProduct cambie
  useEffect(() => {
    if (!tempResumenData?.product?.smallname) {
      console.warn("smallname no está definido");
      return; // Salir si no hay un smallname válido
    }

    let panelAdmin = identifyPanel(tempResumenData?.product?.smallname)
    let filteredOptions = tempResumenData?.sos?.length 
    ? tempResumenData.sos.map(item => item.sosName) 
    : [];
    setOptionsBase(filteredOptions);
    setSelectedOption2(filteredOptions[0]);
    if (typeProduct && tempResumenData) {
      const productActual = resumenData.filter((element) => element.actual && element.type !== "domain");
      const updatedDomainSection = typeProduct === 'vps' ? [
        { dominio_principal: null,
          so: filteredOptions[0],
          panel_admin: panelAdmin !== "Sin panel" ? panelAdmin : undefined // Solo agregar si tiene un valor válido
        },
      ] : [
        { dominio_principal: null }
      ];

      // si existe un producto en el resumen, validamos que sea el mismo producto
      if (productActual.length > 0 && productActual[0]?.product?.name ===tempResumenData.product.name && productActual[0]?.product?.id ===tempResumenData.product.id){
        dispatch(updateResumenData({
          id: productActual[0].id,
          updates: {
            ...productActual[0],
            price: {...tempResumenData.price},
            periodo: tempResumenData.periodo
          }
        }));
        //
        handleOptionChange(selectedOption);
      } else {
        dispatch(addResumenData({
          ...tempResumenData,
          product: {
            ...tempResumenData.product,
            domain_section: updatedDomainSection
          }
        }));
      }
  
      // Limpiar tempResumenData después de usarlo
      setTempResumenData(null);
    }
  }, [typeProduct, tempResumenData]);

  const handleOptionChange = (index) => {
    setSelectedOption(index); 
    resumenData.forEach(element => {
      if(element.type != 'domain' && element.actual == true){
        let cross = parseFloat(productInfo.data[index].Precio.replace(/,/g, '')) < parseFloat(productInfo.data[index].Descuento.replace(/,/g, '')) ? true : false;
        let  newPrice = {
          cost: productInfo.data[index].Descuento,
          cross_price: cross,
          second_price: productInfo.data[index].Precio
        };
        let newPeriod = productInfo.data[index].Periodo;
        dispatch(updatePrice({ id: element.id, newPrice }));
        dispatch(updateResumenProperty({ id: element.id, property:"periodo", value:newPeriod }));
      }
    });
    dispatch(setDescuentoTotal(0));
    resumenData.forEach(resumen => {
      if(resumen.descuento != undefined){
        dispatch(updateDescuento({ iddesc:resumen.id, descuentotxt:null }));
      }
    }); 
    dispatch(setDescuento(null));
  };

  // Destructurar los datos del productInfo
  const { Periodicidades, hname, data, name } = productInfo;

  // Verificar si Periodicidades es true
  const showTable = Periodicidades && data;
  if (loading) {
    return <div></div>;
  }

  const handleChangeSsl = (event) => {
    const { value } = event.target;
    setSslDominio(value);
  
    const isValidDomainValue = isValidDomain(value);
    let domMod, domType = null;
  
    if (isValidDomainValue) {
      domMod = value;
      domType = 'nodomain';
    } else {
      domMod = null;
      domType = null;
    }
  
    resumenData.forEach(element => {
      if (element.actual && element.type === 'ssl') {
        dispatch(updateDominioPrincipal({ id: element.id, dominioPrincipal: domMod, domainType: domType }));
      }
    });
  
    setIsValid(isValidDomainValue); 
  };
  
  function isValidDomain(domain) {
    // Expresión regular para validar un dominio sin www y con extensiones de 2 a 3 caracteres
    const domainPattern = /^(?!www\.)((?!-)[A-Za-z0-9-]{1,63}(?<!-)\.){1,3}([A-Za-z]{2,63}|xn--[A-Za-z0-9]{1,59})$/;
    return domainPattern.test(domain);
  }

  const getIconKey = (selectedOption) => {
    if (!selectedOption) return null; // Si no hay opción seleccionada, retorna null
  
    const lowerOption = selectedOption.toLowerCase(); // Convierte todo a minúsculas
  
    if (lowerOption.includes("almalinux")) return "AlmaLinux v9.0"; // Clave existente en icons
    if (lowerOption.includes("ubuntu")) return "Ubuntu 24.04 LTS";
    if (lowerOption.includes("debian")) return "Debian 12.4";
  
    return null; // Si no coincide, retorna null
  };
  const iconKey = getIconKey(selectedOption2);
  const iconSrc = iconKey ? icons[iconKey] : alma;
  return (
    <div className="col-md-7 col-sm-12 col-xs-12 cf-content">
        <CartSteps numberStep={1} />

        {!showTable ? (
          <div className="cf-period">
            <h1>{t('cart.config.plan_seleccionado')}</h1>
            <div className='cf-plan-select'>
              <span className="cf-plan-select-left">Hosting {hname}  -  <span>1 Año(s)</span></span>
              {leyendaDescu && 
                <span className="cf-plan-select-right" dangerouslySetInnerHTML={{ __html: leyendaDescu }} />
              }
            </div>
          </div>
        ) : (
          typeProduct === 'hosting' ? (
            <div className="cf-period">
              <h1>{t('cart.config.title')}</h1>
              <h5>{t('cart.config.hosting.title')}</h5>
              <p>{t('cart.config.hosting.text')}</p>

              <table className='cf-table'>
                <thead></thead>
                <tbody>
                  {data.map((plan, index) => (
                    <tr key={index} className={`cf-table-tr ${selectedOption === index ? 'cf-active' : ''}`} onClick={()=>{document.getElementById(`opcion${index + 1}`).click()}}>
                      <td className='cf-table-period cart-radio'>
                        <input 
                          type="radio" 
                          name="opciones" 
                          id={`opcion${index + 1}`} 
                          onChange={() => handleOptionChange(index)} 
                          checked={selectedOption === index}
                        />
                        <label htmlFor={`opcion${index + 1}`}>{plan.Periodo}</label>
                      </td>
                      <td className='cf-table-desc'>
                        <span className="cf-light-descuento">
                          <span 
                          className="cf-light-descuento" 
                          dangerouslySetInnerHTML={{ __html: plan.Descripción }} 
                          />
                        </span>
                      </td>
                      <td className='cf-table-price'>
                        {plan.DescuentoMostrar ? (
                          <>
                            {plan.Precio != plan.Descuento && 
                              <span className='cf-table-price-desc nobreak-word' style={{ textDecoration: 'line-through' }}>
                                $ {plan.Precio} {currency}
                              </span>
                            }
                            <span className='nobreak-word'>$ {plan.Descuento} {currency}</span>
                          </>
                        ) : plan.Descuento !== '' ? (
                          <>
                            <span className='cf-table-price-desc nobreak-word' style={{ textDecoration: 'line-through' }}>
                              $ {plan.Descuento} {currency}
                            </span>
                            <span className='nobreak-word'>$ {plan.Precio} {currency}</span>
                          </>
                        ) : (
                          <span className='nobreak-word'>
                            $ {plan.Precio} {currency}
                          </span>
                        )}
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          ) : typeProduct === 'vps' ? (
            <div className="cf-period">
              <h1>{t('cart.config.title')}</h1>
              <h5>{t('cart.config.vps.title')}</h5>
              <p>{t('cart.config.vps.text')}</p>

              {!isEditing ? (
                <div className="cf-period-options">
                  <div className="selected-option">
                    <img src={iconSrc} alt={selectedOption2} className="icon-vps" />
                    <span className="text">{selectedOption2}</span>
                    <button className="edit-button" onClick={() => setIsEditing(true)}><LuPencilLine /> {t('cart.btn.edit')}</button>
                  </div>
                </div>
              ) : (
                <div className="cf-period-options">
                  <ul className="options-list">
                    {optionsBase.map(option => (
                      <li key={option} className="option-item" onClick={() => handleSelect2(option)} >
                        <label>
                          <input 
                            type="radio" 
                            name="osOptions" 
                            value={option} 
                            checked={selectedOption2 === option} 
                            onChange={() => handleSelect2(option)}
                          />
                          <span className="text">{option}</span>
                        </label>
                      </li>
                    ))}
                  </ul>
                </div>
              )}
           </div>
          ) : typeProduct === 'ssl' ? (
            <div className="cf-period">
              <h1>{t('cart.config.title')}</h1>
              <h5>{t('cart.config.ssl.title')}</h5>
              <p dangerouslySetInnerHTML={{ __html: t('cart.config.ssl.text') }} />

              <div className='ssl-dominio-input'>
                <img src={icon} alt="Icon Busqueda" className="ssl-search-icon" />
                <input
                  type="text"
                  id="ssl-input-dominio"
                  className={`form-control ssl-input  ${!isValid ? 'input-error' : ''}`}
                  value={SslDominio}
                      placeholder={t('cart.config.ssl.input.placeholder')}
                  onChange={handleChangeSsl}
                  onFocus={() => setIcon(bsqicon2)} 
                  onBlur={() => setIcon(bsqicon)} 
                />
              </div><br></br>
              <span className="ssl-recordar"><b>{t('cart.config.ssl.disclaimer.remember')}</b> {t('cart.config.ssl.disclaimer.text')}</span>
            </div>
          ) : typeProduct === 'nbps' ? (
            <div className="cf-period">
              <h1>{t('cart.config.plan_seleccionado')}</h1>
              <div className='cf-plan-select'>
                <span className="cf-plan-select-left">{name}</span>
                {leyendaDescu && 
                  <span className="cf-plan-select-right" dangerouslySetInnerHTML={{ __html: leyendaDescu }} />
                }
              </div>
            </div>
          ) :  (
            <div className="cf-period"></div>
          )
        )}
        {typeProduct !== 'ssl' && typeProduct !== 'nbps' && (
          <div className="row">
            <Dominio/>
          </div>
        )}
        {/* <button onClick={handleClearResumenData} style={{ opacity: '2%' }}>Borrar</button>*/}
    </div>
  );
}

export default Configuracion;